/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".flipped[_ngcontent-%COMP%] {\n  -webkit-transform: scaleX(-1);\n          transform: scaleX(-1);\n}\n\nimg[_ngcontent-%COMP%] {\n  height: 32px;\n}\n\n.left[_ngcontent-%COMP%] {\n\n}\n\n.middle[_ngcontent-%COMP%] {\n  margin: 0 0 0 7px;\n  height: 20px;\n}\n\n.right[_ngcontent-%COMP%] {\n\n}"];
export { styles as styles };
